module.exports = __webpack_public_path__ + "img/xqimg10.efbfafb7.png";